module.exports = __webpack_public_path__ + "img/FlightData.fda5551a.png";